import React, { useState } from 'react'
import { Button, Card, Col, Container, Form, FormFeedback, Input, Label, Row, Spinner, UncontrolledTooltip } from 'reactstrap';
import AuthSlider from '../authCarousel';
import { ToastContainer } from 'react-toastify';
import '../../../assets/scss/pages/authCustem.scss';
import withRouter from 'Components/Common/withRouter';
import { useDispatch, useSelector } from 'react-redux';
import { userChangePassword } from 'live-slices/thunk';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';


const ChangePassword = () => {

    const [oldPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [validationError, setValidationError] = useState("");
    const [newPasswordShow, setNewPasswordShow] = useState<boolean>(false);
    const [passwordShow, setPasswordShow] = useState<boolean>(false);

    const dispatch = useDispatch<any>();
        const navigate = useNavigate();

    const { changeSuccessMsg, changeError } = useSelector(
        (state: any) => state.changepwd
    );
    const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);


    // const handleSubmit = (e: any) => {
    //     e.preventDefault();
    //     setValidationError("");

    //     if (newPassword.length > 20 || confirmPassword.length > 20) {
    //         setValidationError("Password must not exceed 20 characters.");
    //         return;
    //     }

    //     if (newPassword.length < 8) {
    //         setValidationError("Password must be at least 8 characters long.");
    //         return;
    //     }

    //     if (!/[A-Z]/.test(newPassword)) {
    //         setValidationError("At least one uppercase letter.");
    //         return;
    //     }

    //     if (!/[0-9]/.test(newPassword)) {
    //         setValidationError("At least one number.");
    //         return;
    //     }

    //     if (newPassword !== confirmPassword) {
    //         setValidationError("Passwords do not match.");
    //         return;
    //     }

    //     const passwordData = { oldPassword, newPassword };
    //     dispatch(userChangePassword(passwordData));
    // };

    const validationSchema = Yup.object({
        oldPassword: Yup.string()
            .required("Old password is required"),

        newPassword: Yup.string()
            .required("New password is required")
            .min(8, "Password must be at least 8 characters")
            .max(20, "Password must not exceed 20 characters")
            .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
            .matches(/[0-9]/, "Password must contain at least one number"),

        confirmPassword: Yup.string()
            .required("Confirm password is required")
            .oneOf([Yup.ref('newPassword')], "Passwords do not match")
            .label("Confirm Password"),
    });


    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        },
        validationSchema,
        onSubmit: (values) => {
            dispatch(userChangePassword( values , navigate));
          
        },
    });

    return (
        <div>
            <React.Fragment>

                <ToastContainer />


                <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100 auth-form mobileScrolHight" >
                    <div className="bg-overlay "></div>
                    <div className="auth-page-content overflow-hidden ">
                        <Container>
                            <Row>
                                <Col lg={12}>
                                    <Card className="Specific-Class-for-border cardHightDv overflow-hidden">
                                        <Row className="g-0 h-100 resModile">
                                            <AuthSlider />
                                            <Col lg={6}  >
                                                <div className='d-flex justify-content-center align-items-center h-100' >
                                                    <div className="height-of-login px-lg-5 px-4 py-2 mainBx">

                                                        <div className='resLoginDiv mb-3'>
                                                            <h1>Change Password</h1>
                                                            <p>Update your password to keep your account secure.</p>
                                                        </div>

                                                        {/* <Form onSubmit={handleSubmit}> */}
                                                        <form onSubmit={formik.handleSubmit}>
                                                            <div className="formContainer mobileResPass">
                                                                <label className="form-label mt-2" htmlFor="user-input">
                                                                    <span className=" me-1">Old Password
                                                                    </span>
                                                                </label>
                                                                <Input
                                                                    type={passwordShow ? "text" : "password"}
                                                                    className={`form-control ${formik.touched.oldPassword && formik.errors.oldPassword
                                                                        ? "is-invalid"
                                                                        : ""
                                                                        }`}
                                                                    placeholder="Enter password"
                                                                    id="oldpasswordInput"
                                                                    data-testing-Id="oldPassword_login"
                                                                    name="oldPassword"
                                                                    value={formik.values.oldPassword}

                                                                    // onChange={(e) => setCurrentPassword(e.target.value)}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    required
                                                                    data-testing-id="oldPasswordInput_Setting"
                                                                />
                                                                {formik.touched.oldPassword && formik.errors.oldPassword ? (
                                                                    <FormFeedback type="invalid" lassName='positoleft'>
                                                                        {formik.errors.oldPassword}
                                                                    </FormFeedback>
                                                                ) : null}
                                                                <button
                                                                    className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                                    onClick={() => setPasswordShow(!passwordShow)}
                                                                    type="button"
                                                                    id="password-addon"
                                                                    data-testing-id="eyeIcon_Setting"
                                                                >
                                                                    <i className="ri-eye-fill align-middle"></i>
                                                                </button>

                                                            </div>

                                                            <div className="formContainer mobileResPass">
                                                                <label className="form-label mt-2" htmlFor="user-input">
                                                                    <span className=" me-1">New Password</span>
                                                                </label>
                                                                <Input
                                                                    type={newPasswordShow ? "text" : "password"}
                                                                    className={`form-control ${formik.touched.newPassword && formik.errors.newPassword
                                                                        ? "is-invalid"
                                                                        : ""
                                                                        }`}
                                                                    placeholder="Enter password"
                                                                    id="newPassword"
                                                                    name="newPassword"
                                                                    value={formik.values.newPassword}
                                                                    // onChange={(e) => {
                                                                    //     const value = e.target.value;
                                                                    //     if (value.length <= 20) {
                                                                    //         setNewPassword(value);
                                                                    //         setValidationError("");
                                                                    //     } else {
                                                                    //         setValidationError("Password must not exceed 20 characters.");
                                                                    //     }
                                                                    // }}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    required
                                                                    data-testing-id="newPasswordInput_Setting"
                                                                />
                                                                {formik.touched.newPassword && formik.errors.newPassword ? (
                                                                    <FormFeedback type="invalid" lassName='positoleft'>
                                                                        {formik.errors.newPassword}
                                                                    </FormFeedback>
                                                                ) : null}
                                                                <button
                                                                    className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                                    onClick={() => setNewPasswordShow(!newPasswordShow)}
                                                                    type="button"
                                                                    id="password-addon"
                                                                    data-testing-id="eyeIcon_Setting"
                                                                >
                                                                    <i className="ri-eye-fill align-middle"></i>
                                                                </button>
                                                            </div>


                                                            <div className="formContainer mobileResPass">
                                                                <label className="form-label mt-2" htmlFor="user-input">
                                                                    <span className=" me-1">Confirm Password</span>
                                                                </label>
                                                                <Input
                                                                    type={confirmPasswordShow ? "text" : "password"}
                                                                    className={`form-control ${formik.touched.confirmPassword && formik.errors.confirmPassword
                                                                        ? "is-invalid"
                                                                        : ""
                                                                        }`}
                                                                    placeholder="Confirm password"
                                                                    id="confirmpasswordInput"
                                                                    name="confirmPassword"
                                                                    value={formik.values.confirmPassword}
                                                                    // onChange={(e) => {
                                                                    //     const value = e.target.value;
                                                                    //     if (value.length <= 20) {
                                                                    //         setConfirmPassword(value);
                                                                    //         setValidationError("");
                                                                    //     } else {
                                                                    //         setValidationError("Password must not exceed 20 characters.");
                                                                    //     }
                                                                    // }}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    required
                                                                    data-testing-id="confirmPasswordInput_Setting"
                                                                />
                                                                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                                                    <FormFeedback type="invalid" lassName='positoleft'>
                                                                        {formik.errors.confirmPassword}
                                                                    </FormFeedback>
                                                                ) : null}
                                                                {/* <button
                                                                    className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                                    onClick={() =>
                                                                        setConfirmPasswordShow(!confirmPasswordShow)
                                                                    }
                                                                    type="button"
                                                                    id="password-addon"
                                                                    data-testing-id="eyeIcon_login"
                                                                >
                                                                    <i className="ri-eye-fill align-middle"></i>
                                                                </button> */}


                                                                <button
                                                                    className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                                    onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
                                                                    type="button"
                                                                    id="password-addon"
                                                                    data-testing-Id="eyeIcon_login"
                                                                >
                                                                    <i className="ri-eye-fill align-middle"></i>
                                                                </button>

                                                            </div>

                                                            <div className="text-center mt-4 d-flex">
                                                                <Button style={{ color: "#2977ff" }} className="w-100" type="submit">
                                                                    <p style={{ color: "#fff" }}> Update Password</p>
                                                                </Button>
                                                            </div>
                                                            {/* </Form> */}
                                                        </form>


                                                    </div>


                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </React.Fragment>
        </div>
    )
}

export default withRouter(ChangePassword);
function dispatch(arg0: any) {
    throw new Error('Function not implemented.');
}

